import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';
import { updateUserSkillNudgesCache } from './updateUserSkillNudgesCache';

const BULK_ACCEPT_USER_SKILL_NUDGE = gql`
  mutation bulkAcceptUserSkillNudge($userUri: String!, $nudgeIds: [String!]!) {
    bulkAcceptUserSkillNudge(userUri: $userUri, nudgeIds: $nudgeIds) {
      nudges {
        nudgeId
      }
      errors {
        nudge {
          nudgeId
        }
        error
      }
    }
  }
`;

const useBulkAcceptUserSkillNudge = ({ userUri }) => {
  const [bulkAcceptUserSkillNudgeMutation] = useMutation(
    BULK_ACCEPT_USER_SKILL_NUDGE,
    {}
  );

  const bulkAcceptUserSkillNudge = useCallback(
    async nudgeIds => {
      return bulkAcceptUserSkillNudgeMutation({
        variables: {
          userUri,
          nudgeIds
        },
        update: (cache, mutationResponse) =>
          updateUserSkillNudgesCache({
            cache,
            userUri,
            nudgeIds: mutationResponse.data?.bulkAcceptUserSkillNudge.nudges.map(
              nudge => nudge.nudgeId
            )
          })
      });
    },
    [bulkAcceptUserSkillNudgeMutation, userUri]
  );

  return { bulkAcceptUserSkillNudge };
};

export default useBulkAcceptUserSkillNudge;
